import { useState, useCallback } from 'react';

function useConfirmModal() {
    const [modalState, setModalState] = useState({
        show: false,
        action: null,
        onConfirm: null,
    });

    const showConfirmModal = useCallback((action, onConfirm) => {
        setModalState({ show: true, action, onConfirm });
    }, []);

    const closeConfirmModal = useCallback(() => {
        setModalState({ show: false, action: null, onConfirm: null });
    }, []);

    const handleConfirmModal = useCallback(() => {
        if (modalState.onConfirm) modalState.onConfirm();
        closeConfirmModal();
    }, [modalState.onConfirm, closeConfirmModal]);

    return {
        setConfirmModal: {
            show: modalState.show,
            action: modalState.action,
            onClose: closeConfirmModal,
            onConfirm: handleConfirmModal,
        },
        showConfirmModal: showConfirmModal,
    };
}
export default useConfirmModal;